import { base64EncodeWithoutPadding } from "@/helpers/data.utils";

export const parseShowcaseTargetURI = (uri = "", targetKind) => {
  const splitParts = uri?.replace("artist;", "artists;")?.split(";");

  if (splitParts?.length < 2 || splitParts?.length > 3) return;

  const [type, target, version] = splitParts;

  if (!type || !target) return;

  if (type === "showcase") {
    return `/pages/${base64EncodeWithoutPadding(version)}/${target}`;
  }

  return targetKind
    ? `/${type}/${target}?kind=${targetKind}`
    : `/${type}/${target}`;
};

export const parseMovieSliderTargetURI = (uri = "", targetKind) => {
  const targetType = uri?.replace("artist;", "artists;")?.split(";")?.[0];
  const shouldOmitProgramKind =
    targetKind === "program" && ["category", "genre"].includes(targetType);

  return parseShowcaseTargetURI(
    uri,
    shouldOmitProgramKind ? undefined : targetKind
  );
};
